<app-collapsible-container
    [id]="'schoolSettings'"
    [title]="'REPERTOIRE.FORMS.SETTINGS.ADULT.TITLE'"
    [icon]="'i-cog'"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <div class="form-control">
        <app-switch-input
            [formControl]="calendar"
            [label]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.CALENDAR-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.CALENDAR-TITLE'"
        >
            <div [ngClass]="{ disabled: !calendar.value }" class="icon icon__settings"></div>
        </app-switch-input>
    </div>

    <!--MEDIAS-->
    <div class="form-control">
        <app-switch-input
            [formControl]="isMediasActive"
            [label]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.MEDIAS-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.MEDIAS-TITLE'"
        >
            <div [ngClass]="{ disabled: !isMediasActive.value }" class="icon icon__settings"></div>
        </app-switch-input>
    </div>

    <!--MEDIAS SUB_OPTIONS-->
    <div *ngIf="isMediasActive.value" class="switch-container">
        <div class="form-control">
            <label>{{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.STORAGE_CAPACITY_TITLE' | translate }}</label>
            <app-generic-select
                [config]="{
                    formGroupName: 'storage_type_id',
                    choices: storageEnumChoices$ | async
                }"
                [formControl]="storageTypeId"
                [isValid]="storageTypeId.valid"
                [placeholder]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.STORAGE_CAPACITY_PLACEHOLDER'"
            >
            </app-generic-select>
        </div>
    </div>

    <!--SHOP-->
    <div class="form-control">
        <app-switch-input
            [formControl]="isShopActive"
            [label]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.SHOP-LABEL'"
            [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.SHOP-TITLE'"
        >
            <div [ngClass]="{ disabled: !isShopActive.value }" class="icon icon__settings"></div>
        </app-switch-input>
    </div>

    <!--SHOP SUB_OPTIONS-->
    <div *ngIf="isShopActive.value" class="switch-container">
        <div class="form-control">
            <app-switch-input [formControl]="meals" [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.MEALS-TITLE'"> </app-switch-input>
        </div>
        <div class="form-control">
            <app-switch-input [formControl]="nursery" [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.NURSERY-TITLE'"> </app-switch-input>
        </div>
        <div class="form-control">
            <app-switch-input [formControl]="homeworks" [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.HOMEWORKS-TITLE'"> </app-switch-input>
        </div>
        <div class="form-control">
            <app-switch-input [formControl]="activities" [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.ACTIVITIES-TITLE'"> </app-switch-input>
        </div>
        <div class="form-control">
            <app-switch-input [formControl]="electronicPayments" [title]="'REPERTOIRE.FORMS.SETTINGS.SCHOOL.ELECTRONIC-PAYMENT-TITLE'">
            </app-switch-input>
        </div>
    </div>
</app-collapsible-container>
